import { useSelector } from "react-redux";
import { useQuery } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";

const isValidId = (value) =>
  value !== null &&
  value !== undefined &&
  value !== "" &&
  value !== "null" &&
  value !== "undefined";

export const useActiveConsultationReferral = (consultationId) => {
  const tenantVal =
    useSelector((state) => state.auth.user?.tenant) ||
    localStorage.getItem("kinesin-tenant");

  return useQuery({
    queryKey: ["activeConsultationReferral", tenantVal, consultationId],
    queryFn: async () => {
      const axiosInstance = await createAxiosInstance();
      const response = await axiosInstance.get(
        `${tenantVal}/patientreferral/getbyconsultationid/${consultationId}`
      );
      return response.data;
    },
    enabled: isValidId(consultationId) && !!tenantVal,
    meta: { errorMessage: "Error fetching referrals" },
  });
};
